import Image from "next/legacy/image";
import Link from "next/link";

import { Button, Card, Skeleton } from "@chef/components";
import { BRAND_PATHS } from "@chef/constants";
import { useBillingQuery } from "@chef/state-management";
import { getImageFromImages } from "@chef/state-management/helpers";
import { isEmptyArray, isNotEmptyArray } from "@chef/utils/array";
import { isGroceryBasketType } from "@chef/helpers";

import { isMyAccountSubscriptionProduct } from "../../utils";

import { intl } from "./AddonSection.Intl";

export const AddonSection = () => {
  const { data: billingQuery, isLoading: isLoadingBilling } = useBillingQuery();

  const addons =
    billingQuery?.billing.baskets
      .find(isGroceryBasketType)
      ?.basketProducts.filter((basketProduct) =>
        isMyAccountSubscriptionProduct(basketProduct.variation.product),
      ) || [];

  const MAX_VISIBLE_CARDS = 4;
  const visibleCardsCount =
    addons.length > MAX_VISIBLE_CARDS
      ? MAX_VISIBLE_CARDS - 1
      : MAX_VISIBLE_CARDS;

  return (
    <section>
      <Card className="flex flex-col" id="abonnement-special-items-card">
        <h2 className="text-xl">
          <strong>{intl.ADDONS}</strong>
        </h2>

        <div className="mt-3">
          {isLoadingBilling && (
            <div className="flex flex-col gap-2 mb-2">
              <Skeleton height={4} />
              <Skeleton height={4} width={80} />
            </div>
          )}

          {!isLoadingBilling && isEmptyArray(addons) && (
            <p className="text-sm">{intl.YOU_MAY_ADD_ADDONS_FOR_EXAMPLE}</p>
          )}

          {!isLoadingBilling && isNotEmptyArray(addons) && (
            <div>
              <p className="text-sm">
                {intl.YOU_SUBSCRIBE_TO_THE_FOLLOWING_ADDONS}
              </p>

              <div className="grid grid-cols-4 gap-2 mt-3">
                {addons.slice(0, visibleCardsCount).map((addon) => {
                  const imageUrl = getImageFromImages({
                    images: addon.variation.images,
                    size: "THUMBNAIL",
                  });

                  return (
                    <div
                      key={addon.variation.variationId}
                      className="flex flex-col gap-2"
                    >
                      <Image
                        layout="responsive"
                        width={72}
                        height={107}
                        src={imageUrl}
                        alt={addon.variation.name}
                      />
                      <p
                        className="text-xs truncate md:text-sm md:whitespace-normal"
                        title={addon.variation.name}
                      >
                        {addon.variation.name}
                      </p>
                    </div>
                  );
                })}

                {addons.length > MAX_VISIBLE_CARDS && (
                  <div className="flex items-center justify-center bg-grey-3">
                    + {addons.length - visibleCardsCount}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        <Link
          href={BRAND_PATHS.ADDONS_SUBSCRIPTION_PATH}
          passHref
          legacyBehavior
        >
          <Button small primary className="self-start mt-8 text-sm">
            {intl.ADDONS_BUTTON(addons.length)}
          </Button>
        </Link>
      </Card>
    </section>
  );
};
